const user = {
  first_name: "First name",
  last_name: "Last name",
  name: "Name",
  email: "Email address",
  gender: "Gender",
  address: "Address",
  phone_number: "Mobile number",
  birthday_with_format: "Date of birth mm/dd/yyyy",
  birthday: "Date of birth",
  gender_options: {
    male: "Male",
    female: "Female",
    unspecified: "Unspecified",
  },
  culture: {
    mexico: "Mexico",
    el_salvador: "El Salvador",
    guatemala: "Guatemala",
    united_states: "United States",
    colombia: "Colombia",
    puerto_rico: "Puerto Rico",
    costa_rica: "Costa Rica",
    cuba: "Cuba",
    nicaragua: "Nicaragua",
    ecuador: "Ecuador",
    unknown: "Unknown",
    honduras: "Honduras",
    argentina: "Argentina",
    bolivia: "Bolivia",
    chile: "Chile",
    dominican_republic: "Dominican Republic",
    panama: "Panama",
    paraguay: "Paraguay",
    peru: "Peru",
    spain: "Spain",
    uruguay: "Uruguay",
    venezuela: "Venezuela",
    other: "Not listed here"
  },
  culture_id: "Select your family’s country of origin",
  other_culture_name: "Please specify your family’s country of origin",
  mexico_state_id: "Which Mexico state does your family come from?",
  interests: "Interests",
  language: "Language",
  language_options: {
    spanish: "Spanish",
    english: "English",
  },
  profile: {
    header_title: "Your Account",
    logout_cta: "Logout",
    edit_cta_title: "Basic Info",
    edit_cta: "Edit",
    cancel_edit_cta: "Cancel",
    submit_cta: "Submit Changes",
    payment_cta_title: "Payment Info",
    payPastDue_cta: "Pay Now",
    basic_member: {
      upgrade_premium_message: "Upgrade to premium to unlock all benifits for",
      unlock_benifit_cta: "Unlock benifits now!",
      duration: "/ month"
    },
    podercard_alert: {
      title: "Oops!",
      subtitle:
        "Since you’ve enrolled in PODERcard these edits can only be made there",
      open: "Open PODERcard App",
      cancel: "Cancel",
    },
    terms_and_condition: "Terms and Conditions and Privacy Policy",
  },
};

export default user;
